import { Navigate } from "react-router-dom";
import MainLayout from "../components/Layouts/MainLayout";
import FeelingAnalysis from "../features/feelingAnalysis/pages/FeelingAnalysis";
import Topics from "../features/topics/pages/Topics";
import Dashboard from "../features/Dashboard/pages/Dashboard";
import Historical from "../features/historicalData/pages/Historical";
import Alerts from "../features/alerts/pages/Alerts";
import Admin from "../features/admin/generic/pages/Admin";
import TemplateList from "../features/admin/templates/pages/TemplateList";
import ClientsList from "../features/admin/client/pages/ClientsList";
import User from "../features/admin/users/pages/UsersList";
import NewClient from "../features/admin/client/pages/NewClient";
import UserForm from "../features/admin/users/pages/UserForm";
import Home from "../features/admin/generic/pages/Home";
import TemplateForm from "../features/admin/templates/pages/TemplateForm";
import GlobalDashboardLayout from "../components/Layouts/GlobalDashboardLayout";
import NewClaim from "../features/claims/pages/NewClaim";
import ClaimDashboardLayout from "../components/Layouts/ClaimDashboardLayout";
import HistoricalClaims from "../features/claims/pages/HistoricalClaims";
import ParticipantsList from "../features/admin/participants/pages/ParticipantsList";
import ParticipantForm from "../features/admin/participants/pages/ParticipantForm";
import CampaignForm from "../features/admin/campaign/pages/CampaignForm";
import CampaignsList from "../features/admin/campaign/pages/CampaignsList";
import SurveyList from "../features/admin/surveys/pages/SurveyList";
import EditClaim from "../features/claims/pages/EditClaim"
import EditClaimData from "../features/claims/components/edit/EditClaimData";
import EditClaimDocument from "../features/claims/components/edit/EditClaimDocument";
import EditClaimRecomendation from "../features/claims/components/edit/EditClaimRecomendation";
import DashboardClaim from "../features/claims/pages/DashboardClaim";
import MotiuReobrirQueixa from "../features/admin/Dictionaries/pages/ClaimReopenReason";
import SurveyClosedReason from "../features/admin/Dictionaries/pages/SurveyClosedReason";
import FunctionalAreas from "../features/admin/Dictionaries/pages/FunctionalAreas";
import SurveyForm from "../features/admin/surveys/pages/SurveyForm";
import ServiceIndicators from "../features/admin/Dictionaries/pages/ServiceIndicators";
import AuditLogsList from "../features/auditLogs/pages/AuditLogsList";
import EditClaimFollowUp from "../features/claims/components/edit/ClaimFollowUpList";
import InitialRedirect from "./InitialRedirect";
import SentimentAnalysis from "../features/admin/sentimentAnalysis/pages/sentimentAnalysis";
import GeneralParamsForm from "../features/admin/generalParams/pages/GeneralParamsForm";
import RolesList from "../features/admin/roles/pages/RolesList";
import { PERMISSIONS } from "../constants/permissions";
import AlertValuesList from "../features/admin/alertValues/pages/AlertValuesList";
import EventsList from "../features/admin/events/pages/EventsList";
import ClaimDeleteReason from "../features/admin/Dictionaries/pages/ClaimDeleteReason";
import ClaimCancelReason from "../features/admin/Dictionaries/pages/ClaimCancelReason";
import AlertDeleteReason from "../features/admin/Dictionaries/pages/AlertDeleteReason";
import ClaimOrigin from "../features/admin/Dictionaries/pages/ClaimOrigin";
import DemandInFormat from "../features/admin/Dictionaries/pages/DemandInFormat";
import DictionaryFormPage from "../features/admin/Dictionaries/pages/DictionaryFormPage";
import ImprovementPlanType from "../features/admin/Dictionaries/pages/ImprovementPlanType";
import ImprovementPlanOrigin from "../features/admin/Dictionaries/pages/ImprovementPlanOrigin";
import ImprovementPlanFinalizeReason from "../features/admin/Dictionaries/pages/ImprovementPlanFinalizeReason";
import ImprovementPlanDeleteReasons from "../features/admin/Dictionaries/pages/ImprovementPlanDeleteReasons";
import RolesForm from "../features/admin/roles/pages/RolesForm";
import EventForm from "../features/admin/events/pages/EventForm";
import SentimentForm from "../features/admin/sentimentAnalysis/pages/SentimentForm";
import AlertConfigForm from "../features/admin/alertValues/pages/AlertConfigForm";
import ImprovementPlansList from "../features/improvementPlan/pages/ImprovementPlansList";
import ImprovementPlanForm from "../features/improvementPlan/pages/ImprovementPlanForm";
import ClaimProfessionalType from "../features/admin/Dictionaries/pages/ClaimProfessionalType";
import ClaimFollowUpType from "../features/admin/Dictionaries/pages/ClaimFollowUpType";
import DemandOutFormat from "../features/admin/Dictionaries/pages/DemandOutFormat";
import DemandDerivation from "../features/admin/Dictionaries/pages/DemandDerivation";
import TopicsManagement from "../features/admin/topics/pages/TopicsManagement";
import SecurityIPsList from "../features/admin/securityIPManagement/pages/SecurityIPsList";
import SecurityIPsForm from "../features/admin/securityIPManagement/pages/SecurityIPsForm";
import ExtraFieldList from "../features/admin/surveyImportExtraFields/pages/ExtraFieldList";
import ExtraFieldForm from "../features/admin/surveyImportExtraFields/pages/ExtraFieldForm";
import SurveyImport from "../features/surveyImport/pages/SurveyImport";
import SurveyImportDetail from "../features/surveyImport/pages/SurveyImportDetail";
import SurveyImportForm from "../features/surveyImport/pages/SurveyImportForm";
import ClaimPersonalRelationship from "../features/admin/Dictionaries/pages/ClaimPersonalRelationship";
import ImprovementPlansDashboardLayout from "../components/Layouts/ImprovementPlansDashboardLayout";
import ImprovementPlanDashboard from "../features/improvementPlan/pages/ImprovementPlanDashboard";
import ImprovementPlansGantt from "../features/improvementPlan/pages/ImprovementPlansGantt";
import ClaimRequestTypeList from "../features/admin/claimRequestType/pages/ClaimRequestTypeList";
import ClaimRequestTypeForm from "../features/admin/claimRequestType/pages/ClaimRequestTypeForm";
import OrganizationalStructuresManagement from "../features/admin/organizationalStructures/pages/OrganizationalStructuresManagement";
import UserCommunicationTypeForm from "../features/admin/userCommunicationType/pages/UserCommunicationTypeForm";
import UserCommunicationTypeList from "../features/admin/userCommunicationType/pages/UserCommunicationTypeList";
import CampaignClosedReason from "../features/admin/Dictionaries/pages/CampaignClosedReason";
import ProfessionalList from "../features/profesionals/pages/ProfessionalList";
import ProfessionalForm from "../features/profesionals/pages/ProfessionalForm";
import ReportDefinitionsList from "../features/reportDefinition/pages/ReportDefinitionsList";
import ReportDefinitionForm from "../features/reportDefinition/pages/ReportDefinitionForm";


type PrivateRouteProps = {
    children: React.ReactNode;
};

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
    const token = localStorage.getItem('token');

    if (!token) {
        return <Navigate to="/login" />;
    }

    return <>{children}</>;
};

// Componente para proteger rutas con permisos específicos
const PermissionRoute: React.FC<{ children: React.ReactNode; permission: string }> = ({
    children,
    permission
}) => {
    const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');

    if (!permissions.includes(permission)) {
        return <InitialRedirect />;
    }

    return <>{children}</>;
};

export const protectedRoutes = [
    // Dashboard principal
    {
        path: '/',
        element: (
            <PrivateRoute>
                <MainLayout />
            </PrivateRoute>
        ),
        children: [
            { path: '', element: <InitialRedirect /> },
            { path: 'dashboard', element: <InitialRedirect /> },
            { path: 'new-claim', element: <NewClaim /> },
            { path: 'professionals', element:  <ProfessionalList />},
            { path: 'professionals/new-professional', element: <ProfessionalForm /> },
            { path: 'professionals/:professionalId', element: <ProfessionalForm /> },
            { path: 'alertes', element: <Alerts /> },
            {
                path: 'edit-claim/:idClaim',
                element: <EditClaim />,
                children: [
                    { path: '', element: <Navigate to="data" replace /> },
                    { path: 'data', element: <EditClaimData /> },
                    { path: 'documents', element: <EditClaimDocument /> },
                    { path: 'follow-up', element: <EditClaimFollowUp /> },
                    { path: 'recomendations', element: <EditClaimRecomendation /> }
                ],
            },
            {
                path: 'survey-patient',
                element: (
                    <GlobalDashboardLayout />
                ),
                children: [
                    { path: '', element: <Navigate to="dashboard" replace /> },
                    { path: 'dashboard', element: <Dashboard /> },
                    { path: 'sentiment', element: <FeelingAnalysis /> },
                    { path: 'topics', element: <Topics /> },
                    { path: 'historic', element: <Historical /> },
                ],
            },
            {
                path: 'survey-load',
                element: (
                    <PermissionRoute permission={PERMISSIONS.SURVEY_UPLOAD.VIEW}>
                        <SurveyImport />
                    </PermissionRoute>
                )
            },
            {
                path: 'survey-load/detail-survey-load/:surveyImportId',
                element: (
                    <PermissionRoute permission={PERMISSIONS.SURVEY_UPLOAD.VIEW}>
                        <SurveyImportDetail />
                    </PermissionRoute>
                )
            },
            {
                path: 'survey-load/new-survey-load',
                element: (
                    <PermissionRoute permission={PERMISSIONS.SURVEY_UPLOAD.EDIT}>
                        <SurveyImportForm />
                    </PermissionRoute>
                )
            },
            {
                path: 'claims',
                element: (
                    <PermissionRoute permission={PERMISSIONS.CLAIMS.VIEW}>
                        <ClaimDashboardLayout />
                    </PermissionRoute>
                ),
                children: [
                    { path: '', element: <Navigate to="dashboard" replace /> },
                    { path: 'dashboard', element: <DashboardClaim /> },
                    { path: 'historic', element: <HistoricalClaims /> }
                ],
            },
            {
                path: 'improvement-plans',
                element: (
                    <PermissionRoute permission={PERMISSIONS.IMPROVEMENT_PLANS.VIEW}>
                        <ImprovementPlansDashboardLayout />
                    </PermissionRoute>
                ),
                children: [
                    { path: '', element: <Navigate to="dashboard" replace /> },
                    { path: 'dashboard', element: <ImprovementPlanDashboard /> },
                    { path: 'historic', element: <ImprovementPlansList /> },
                    { path: 'gantt', element: <ImprovementPlansGantt/> }
                ],
            },
            { path: 'improvement-plans/new', element: <ImprovementPlanForm /> },
            { path: 'improvement-plans/:improvementPlanId', element: <ImprovementPlanForm /> },
        ],
    },
    // Rutas de administración
    {
        path: '/admin',
        element: (
            <PrivateRoute>
                <Admin />
            </PrivateRoute>
        ),
        children: [
            { path: '', element: <Home /> },
            { path: 'template', element: <TemplateList /> },
            { path: 'template/:idTemplate', element: <TemplateForm /> },
            { path: 'template/new-template', element: <TemplateForm /> },
            { path: 'client', element: <ClientsList /> },
            { path: 'client/new-client', element: <NewClient /> },
            { path: 'client/edit/:id', element: <NewClient /> },
            { path: 'users', element: <User /> },
            { path: 'users/new-user', element: <UserForm /> },
            { path: 'users/:idUser', element: <UserForm /> },
            { path: 'roles', element: <RolesList /> },
            { path: 'roles/new-role', element: <RolesForm /> },
            { path: 'roles/:roleId', element: <RolesForm /> },
            { path: 'surveyList', element: <SurveyList /> },
            { path: 'surveyList/new-survey', element: <SurveyForm /> },
            { path: 'surveyList/:surveyId', element: <SurveyForm /> },
            { path: 'campaign', element: <CampaignsList /> },
            { path: 'campaign/new-campaign', element: <CampaignForm /> },
            { path: 'campaign/:campaignId', element: <CampaignForm /> },
            { path: 'event', element: <EventsList /> },
            { path: 'event/new-event', element: <EventForm /> },
            { path: 'event/:eventId', element: <EventForm /> },
            { path: 'participants', element: <ParticipantsList /> },
            { path: 'participants/new-participants', element: <ParticipantForm /> },
            { path: 'participants/:participantId', element: <ParticipantForm /> },
            { path: 'editGeneric/:table/:id', element: <DictionaryFormPage /> },
            { path: 'newGeneric/:table', element: <DictionaryFormPage />  },
            { path: 'claimReopenReason', element: <MotiuReobrirQueixa /> },
            { path: 'surveyClosedReason', element: <SurveyClosedReason /> },
            { path: 'claimProfessionalType', element: <ClaimProfessionalType /> },
            { path: 'claimOrigin', element: <ClaimOrigin /> },
            { path: 'demandInFormat', element: <DemandInFormat /> },
            { path: 'alertDeleteReason', element: <AlertDeleteReason /> },
            { path: 'claimDeleteReason', element: <ClaimDeleteReason /> },
            { path: 'surveyPreviousClosed', element: <ClaimDeleteReason /> },
            { path: 'functionalAreas', element: <FunctionalAreas /> },
            { path: 'serviceIndicators', element: <ServiceIndicators /> },
            { path: 'claimPersonalRelationship', element: <ClaimPersonalRelationship /> },
            { path: 'improvementPlanType', element: <ImprovementPlanType /> },
            { path: 'improvementPlanOrigin', element: <ImprovementPlanOrigin /> },
            { path: 'improvementPlanFinalizeReasons', element: <ImprovementPlanFinalizeReason /> },
            { path: 'improvementPlanDeleteReasons', element: <ImprovementPlanDeleteReasons /> },
            { path: 'auditLogs', element: <AuditLogsList /> },
            { path: 'sentiment-analysis', element: <SentimentAnalysis /> },
            { path: 'alertValues', element: <AlertValuesList /> },
            { path: 'alertValues/new-alert-value', element: <AlertConfigForm /> },
            { path: 'alertValues/edit/:id', element: <AlertConfigForm /> },
            { path: 'generic-params', element: <GeneralParamsForm /> },
            { path: 'sentiment-analysis/new-sentiment', element: <SentimentForm /> },
            { path: 'sentiment-analysis/edit/:id', element: <SentimentForm /> },
            { path: 'claimFollowUpType', element: <ClaimFollowUpType /> },
            { path: 'claimCancelReason', element: <ClaimCancelReason /> },
            { path: 'demandOutFormat', element: <DemandOutFormat /> },
            { path: 'demandDerivation', element: <DemandDerivation /> },
            { path: 'topics', element: <TopicsManagement /> },
            { path: 'ips', element: <SecurityIPsList /> },
            { path: 'ips/:ipId', element: <SecurityIPsForm /> },
            { path: 'ips/new-ips', element: <SecurityIPsForm /> },
            { path: 'extraFields', element: <ExtraFieldList /> },
            { path: 'extraFields/:extraFieldId', element: <ExtraFieldForm /> },
            { path: 'claimRequestTypes', element: <ClaimRequestTypeList /> },
            { path: 'claimRequestTypes/:claimRequestTypeId', element: <ClaimRequestTypeForm /> },
            { path: 'claimRequestTypes/new', element: <ClaimRequestTypeForm /> },
            { path: 'organizationalStructures', element: <OrganizationalStructuresManagement /> },
            { path: 'userCommunicationTypes', element: <UserCommunicationTypeList /> },
            { path: 'userCommunicationTypes/:userCommunicationTypeId', element: <UserCommunicationTypeForm /> },
            { path: 'userCommunicationTypes/new', element: <UserCommunicationTypeForm /> },
            { path: 'campaignClosedReason', element: <CampaignClosedReason /> },
            { path: 'report-definitions', element: <ReportDefinitionsList /> },
            { path: 'report-definitions/new', element: <ReportDefinitionForm /> },
            { path: 'report-definitions/:reportDefinitionId', element: <ReportDefinitionForm /> },
        ],
    },
];
